<ion-header no-border mode="md">
    <ion-toolbar color="primary" mode="md">
        <ion-title>
            {{ title | translate }}
        </ion-title>
        <ion-buttons slot="end">
            <ion-button color="light" (click)="close()" mode="ios">
                <ion-icon class="bp-close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content class="content">
    <div class="container-filters">
        <app-attribute-filter *ngFor="let filter of filters" [filter]="filter"></app-attribute-filter>
    </div>
    <div class="divider"></div>
    <div class="footer">
        <button class="btn-clear" mode="ios"
                (click)="clear()">
            {{ 'generic.clear' | translate }}
        </button>
        <ion-button class="btn-save" mode="ios"
                    [color]="'secondary'"
                    (click)="save()">
            {{ 'filters.save' | translate }}
        </ion-button>
    </div>
</ion-content>
